export default "__VITE_ASSET__b53d0a0d__"